import { AuthGuard } from "../../shared/guards/AuthGuard";
import { Sidebar } from "../../shared/components";
import { AgreementsListPresentation } from "./components/AgreementsListPresentation";

export const AgreementsPage = (): JSX.Element => {
	return (
		<AuthGuard>
			<Sidebar>
				<AgreementsListPresentation />
			</Sidebar>
		</AuthGuard>
	);
};
